import { useMemo, useRef, useState } from 'react';
import { useFormik } from 'formik';
import moment from 'moment';
import * as Yup from 'yup';

import { useData } from 'src/contexts/data';
import { ModelOfContractBidding, ModelOfUnityContract } from 'src/database';
import api from 'src/services/api';
import { dateToString } from 'src/utils/dateToString';

export const useFormCreateUnityContract = () => {
	const { currentBidding, selectedBudgetUnit, selectedContractBidding, getBudgetUnits, handleContractBidding } =
		useData();
	const [loading, setLoading] = useState(false);

	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		NUMERO: Yup.string().required('* Campo obgrigatório'),
		CREDOR: Yup.string().required('* Campo obrigatório'),
		DATAASSINATURA: Yup.string().required('* Campo obrigatório'),
		VALOR: Yup.number().required('* Campo obrigatório'),
	});

	const saveUnityContracts = (unityContract: ModelOfUnityContract) => {
		setLoading(true);

		const newUnityContract = {
			...unityContract,
			CONTRATO: currentBidding?.ID,
		};

		api.post('contracts', newUnityContract)
			.then((response) => {
				getBudgetUnits(currentBidding?.ID);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Cadastro realizada',
					detail: 'A unidade foi adicionada com sucesso!',
					life: 5000,
				});
			})
			.catch((err) => {
				console.log(err);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Cadastro não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const saveContractBidding = (unityContract: ModelOfContractBidding) => {
		setLoading(true);

		const newUnityContract = {
			...unityContract,
			DATAASSINATURA: moment(unityContract.DATAASSINATURA, 'DD/MM/YYYY')
				.toDate()
				.toLocaleDateString('en', { year: 'numeric', month: '2-digit', day: '2-digit' }),
			CONTRATOORGAOUNIDADE: selectedBudgetUnit?.ID,
			CONTRATO: currentBidding?.ID,
		};

		if (selectedContractBidding?.ID) {
			api.put(`/bidding-contract/${selectedContractBidding?.ID}`, newUnityContract)
				.then((response) => {
					handleContractBidding({
						...response.data[0],
						DATAASSINATURA: dateToString(response.data[0].DATAASSINATURA, 'br'),
					});
					setLoading(false);
					toast.current.show({
						severity: 'success',
						summary: 'Edição realizada',
						detail: 'O contrato foi editado com sucesso!',
						life: 5000,
					});
				})
				.catch((err) => {
					console.log(err);
					setLoading(false);
					toast.current.show({
						severity: 'error',
						summary: 'Edição não realizada',
						detail: 'Falha ao realizar operação!',
						life: 5000,
					});
				});
		} else {
			api.post('/bidding-contract', newUnityContract)
				.then((response) => {
					handleContractBidding({
						...response.data[0],
						DATAASSINATURA: dateToString(response.data[0].DATAASSINATURA, 'br'),
					});
					setLoading(false);
					toast.current.show({
						severity: 'success',
						summary: 'Cadastro realizado',
						detail: 'O contrato foi cadastrado com sucesso!',
						life: 5000,
					});
				})
				.catch((err) => {
					console.log(err);
					setLoading(false);
					toast.current.show({
						severity: 'error',
						summary: 'Cadastro não realizado',
						detail: 'Falha ao realizar operação!',
						life: 5000,
					});
				});
		}
	};

	const formikUnityContract = useFormik<ModelOfUnityContract>({
		initialValues: {
			CONTRATO: '',
			ORGAOUNIDADE: '',
			TOTALCONTRATADO: 0,
		},
		onSubmit: (values) => saveUnityContracts(values),
	});

	const formikContractBidding = useFormik<ModelOfContractBidding>({
		initialValues: {
			CONTRATO: '',
			CONTRATOORGAOUNIDADE: '',
			NUMERO: '',
			CREDOR: '',
			DATAASSINATURA: '',
			VALOR: 0,
			TOTALADITIVADO: 0,
			OBSERVACAO: '',
			TOTALITEM: 0,
			TOTALEMPENHADO: 0,
		},
		onSubmit: (values) => saveContractBidding(values),
		validationSchema,
	});

	useMemo(() => {
		if (selectedContractBidding == null) {
			formikContractBidding.resetForm();
		}
	}, [selectedContractBidding]);

	return {
		getContractController: {
			formikContractBidding,
			formikUnityContract,
			loading,
			toast,
		},
	};
};
